<div class="successPayment failedPaymentPage"  [ngStyle]="!isLogged ? { 'margin-top': '300px' } : {}" role="main" aria-label="Payment failed page">
    <img src="/assets/images/warning-icon.svg" alt="Warning: payment failed">
    <h3 [appTranslate]="'PAYMENT_FAILED'"></h3>
    <!-- <div>
        <button type="button" class="btn btn-next"  (click)="goToDashboard()"
            [appTranslate]="'MY_REQUIREMENTS'" aria-label="Go to my requirements"></button>
    </div> -->
</div>